import React from 'react';
import { Flex } from '@banhala/ui-kit';

const DOT_SIZE = 7;
const GAP_DOT = 8;

export const PaginationDots: React.FC<{
  value: number;
  maxCount: number;
}> = props => {
  return (
    <Flex.Row gap={GAP_DOT}>
      {Array.from({ length: props.maxCount }).map((_, i) => (
        <Flex
          key={`Pagination_${i}`}
          backgroundColor={'bg_always_white'}
          opacity={props.value === i ? 1 : 0.4}
          width={DOT_SIZE}
          height={DOT_SIZE}
          borderRadius={DOT_SIZE * 0.5}
        ></Flex>
      ))}
    </Flex.Row>
  );
};
